<template>
    <div>
        <b-form-rating v-model="score"  :variant="weightedVariant" no-border readonly></b-form-rating>
    </div>
</template>

<script>
export default {
    name: "Rating",
    props: {
        score: 0,
        warning: false,
    },
    data() {
        return {
            value: 4.6,
            variant: "secondary",
        }
    },
    computed: {
        weightedVariant: function () {
            if (!this.score) {
                return 'secondary';
            }
            if (this.warning) {
                return 'warning';
            }
            if (this.score <= 3.5) {
               return 'danger';
            }
            return 'success';
        },
    }

    }
</script>

<style scoped>

</style>
